import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './assets/theme/theme';
import CssBaseline from '@mui/material/CssBaseline';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
